import type { HTMLProps } from 'react';
import { styled } from 'styled-components';

type Props = {
  value: string;
} & HTMLProps<HTMLDivElement>;

export function KeyShortcut({ value, ...props }: Props) {
  return <Wrapper {...props}>{value.toUpperCase()}</Wrapper>;
}

const Wrapper = styled.span`
  padding: 4px;
  border-radius: 4px;
  background-color: ${props => props.theme.colors.dark.dark200};
  color: ${props => props.theme.colors.white};
  min-width: 24px;
  height: 24px;
  text-align: center;
  font-size: ${props => props.theme.typography.body2.fontSize}px;
`;
